import { render, staticRenderFns } from "./CommPrefs.vue?vue&type=template&id=f171c94c&scoped=true&"
import script from "./CommPrefs.vue?vue&type=script&lang=js&"
export * from "./CommPrefs.vue?vue&type=script&lang=js&"
import style0 from "./CommPrefs.vue?vue&type=style&index=0&id=f171c94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f171c94c",
  null
  
)

export default component.exports